export const implementBuildReport = () => {
    let pageHeader: JQuery<HTMLElement>;
    // let pageFooter: JQuery<HTMLElement>;

    const getPageHeaderFooter = (element: JQuery<HTMLElement>) => {
        let header = element.find('.header');
        pageHeader = header.clone();
        header.remove();
        let footer = element.find('.print-footer');
        // pageFooter = footer.clone();
        footer.remove();
    };

    const splitElement = (
        baseElement: JQuery<HTMLElement>,
        element: JQuery<HTMLElement>,
        redundantHeight: number
    ): {
        reverseHeight: number,
        newChild: HTMLElement[]
    } => {
        let maxHeight = Math.floor(baseElement[0].clientHeight);
        let newChild = [] as HTMLElement[];
        let reverseHeight = redundantHeight;
        let elements = element.children().toArray();
        while (reverseHeight > 0 && elements.length > 0) {
            let childElement = elements.pop()!;
            let childHeight = childElement.scrollHeight;
            if (
                reverseHeight < childHeight &&
                childElement.children.length > 0 &&
                childElement.tagName !== 'TR' &&
                !childElement.classList.contains('nosplit')
            ) {
                let cloneChild = $(childElement).clone().empty();
                let result = splitElement(baseElement, $(childElement), reverseHeight);
                cloneChild.append(result.newChild);
                reverseHeight = result.reverseHeight;
                newChild.unshift(cloneChild[0]);
                if (!childElement.innerText) {
                    childElement.remove();
                }
            } else {
                childElement.remove();
                reverseHeight = baseElement[0].scrollHeight - maxHeight;
                newChild.unshift(childElement);
            }
            if (!childElement.innerText && elements.length === 1 && elements[0].classList.contains('field-header')) {
                let headerElement = elements.pop()!;
                headerElement.remove();
                newChild.unshift(headerElement);
            }
        }
        return { reverseHeight, newChild };
    };

    const splitPage = (baseElement: JQuery<HTMLElement>) => {
        const newBaseElement = $(baseElement[0].children[0]) as JQuery<HTMLElement>;
        let redundantHeight = newBaseElement[0].scrollHeight - Math.floor(newBaseElement[0].clientHeight);
        let result = splitElement(newBaseElement, newBaseElement, redundantHeight);
        if (result.newChild.length > 0) {
            const letter = $('<div class="letter"></div>');
            const letterContent = $('<div class="letter-content statement-letter"></div>');
            letterContent.append(result.newChild);
            letter.append(letterContent);
            baseElement.after(letter);
            splitPage(letter);
        }
    };

    const removeEmptyPage = (element: JQuery<HTMLElement>) => {
        for (let i = element.length - 1; i >= 0; i--) {
            if (!element[i].innerText) {
                element[i].remove();
            }
        }
    };

    const addPageHeaderFooter = (element: JQuery<HTMLElement>) => {
        for (let i = 0; i < element.length; i++) {
            if (element[i].children.item(0)) {
                $(element[i].children.item(0)!).prepend(pageHeader.clone());
            }
            $(element[i]).append('<div class="page-info">Page ' + (i + 1) + ' of ' + element.length + '</div>');
        }
    };

    return () => {
        getPageHeaderFooter($('.letter'));
        splitPage($('.letter'));
        removeEmptyPage($('.letter'));
        addPageHeaderFooter($('.letter'));
    };
};

export const printHTML = (payload: {
    titleId?: string,
    contentId: string
}) => {
    const mywindow = window.open('', 'PRINT', 'height=800,width=1200');
    if (mywindow) {
        const titleElement = payload.titleId && document.getElementById(payload.titleId);
        const contentElement = document.getElementById(payload.contentId);
        mywindow.document.write(
            `<head>${document.head.innerHTML}</head>`,
            `
                <body style="background:white">
                    ${titleElement ? `<h1 style="text-align:center;">${titleElement.innerHTML}</h1>` : ''}
                    ${contentElement ? contentElement.innerHTML : ''}
                </body>
            `
        );

        // wait document loaded
        const intervalId = mywindow.setInterval(
            () => {
                const html = mywindow.document.children.item(0);
                if (html && html.children.length === 2) {
                    window.clearInterval(intervalId);
                    mywindow.print();
                    mywindow.close();
                }
            },
            200
        );
    }
};

export const printHTMLPages = (
    contentIds: string[]
) => {
    const mywindow = window.open('', 'PRINT', `height=600,width=1200`);
    if (mywindow) {
        let contentHTML = '';
        for (let contentId of contentIds) {
            const contentElement = document.getElementById(contentId);
            if (contentElement) {
                contentHTML +=
                    `
                        <div class="letter">
                            ${contentElement.innerHTML}
                        </div>
                    `;
            }
        }

        mywindow.document.write(
            `<head>${document.head.innerHTML}</head>`,
            `<body style="background:white;">${contentHTML}</body>`
        );

        // wait document loaded
        const intervalId = mywindow.setInterval(
            () => {
                const html = mywindow.document.children.item(0);
                if (html && html.children.length === 2) {
                    window.clearInterval(intervalId);
                    mywindow.print();
                    mywindow.close();
                }
            },
            1000
        );
    }
};
